import {formatFieldAsText, strip} from '@/common/questionsExporter/utility'

const sortingQuestion = (question) => {
    const strippedPrompt = strip(question.question)
    const direction = question.direction ? question.direction : ''

    const options = question.options ? question.options : []
    const formattedOptions = options.map(formatFieldAsText).join("\n")

    return `${strippedPrompt}\nDirection: ${direction}\n${formattedOptions}`
}

export {sortingQuestion}
